import { PacketModal } from "features/users";
import {
  Contact,
  Hero,
  WhatInvestorNeeds,
  YourInvestitions,
  AvailablePackages,
  NoObligationAnalysis,
  Succesors,
} from "./components";
import "./Homepage.scss";
import { useState } from "react";
import { useGetMe } from "hooks/auth";
import { useNavigate } from "react-router";
import { ROUTE_ENUM } from "enums";
import { PageHead } from "shared";

type HomepagePageProps = {};

export type HomepageModalType = "packet";

const Homepage: React.FC<HomepagePageProps> = () => {
  const [modalManage, setModalManage] = useState<HomepageModalType | null>(
    null
  );
  const navigate = useNavigate();
  const { data: authorizedUser } = useGetMe();

  return (
    <>
      <PageHead
        title="App Reliance Pro – aplikacja do zarządzania inwestycjami online"
        description="Śledź spółki, otrzymuj aktualizacje rynkowe, zlecaj analizy i przechowuj ważne dokumenty. Bezpieczna aplikacja dla świadomych inwestorów."
      />
      <div className="homepage">
        <PacketModal
          isOpen={modalManage === "packet"}
          onClose={() => {
            setModalManage(null);
            if (!!authorizedUser) {
              navigate(ROUTE_ENUM.COMPANIES);
            }
          }}
          parent="homepage"
        />
        <Hero setModalManage={setModalManage} />
        <WhatInvestorNeeds />
        <YourInvestitions />
        <Succesors />
        <AvailablePackages setModalManage={setModalManage} />
        <NoObligationAnalysis setModalManage={setModalManage} />
        <Contact />
      </div>
    </>
  );
};

export default Homepage;
